@let view = data();

@if (view?.tagline) {
  <div
    [innerHTML]="view?.tagline"
    class="tagline"
  ></div>
}
@switch (level()) {
  @case (1) {
    @if (view?.headline) {
      <h1>{{ view?.headline }}</h1>
    }
    @if (view?.subline) {
      <h2>{{ view?.subline }}</h2>
    }
  }
  @case (2) {
    @if (view?.headline || view?.subline) {
      <h2>
        @if (view?.headline) {
          <strong>{{ view?.headline }}</strong>
        }
        @if (view?.subline) {
          <span>
            <br />{{ view?.subline }}
          </span>
        }
      </h2>
    }
  }
  @case (3) {
    @if (view?.headline) {
      <h3>{{ view?.headline }}</h3>
    }
    @if (view?.subline) {
      <p>{{ view?.subline }}</p>
    }
    @if (view?.bodyCopy) {
      <div [innerHTML]="view?.bodyCopy"></div>
    }
  }
  @default {
    @if (view?.headline) {
      <h4>{{ view?.headline }}</h4>
    }
    @if (view?.subline) {
      <p>{{ view?.subline }}</p>
    }
  }
}
